/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './InsuranceInformation.module.scss'
import { expiryDateAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const ExpiryDate = ({
  t,
  validateExpiryDate,
  expiryDateError,
  expiryDateValid,
  expiryDateDayEl,
  expiryDateMonthEl,
  expiryDateYearEl,
  setIsError,
}) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const { expiryDate } = useSelector((state) => state.app)

  const handleExpiryDateDay = (e) => {
    try {
      const regex = RegExp(/^\d+$/)
      if (regex.test(expiryDateDayEl.current.value)) {
        let value = expiryDateDayEl.current.value
        if (value !== '' && parseInt(value) > 0 && parseInt(value) < 10) {
          value = '0' + value.toString()
        } else {
          value = value.substr(1)
        }
        dispatch(expiryDateAction(`${expiryDateYearEl.current.value}-${expiryDateMonthEl.current.value}-${value}`))
        // validateExpiryDate()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const formatMonth = (monthNumber) => {
    return monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`
  }

  const handleExpiryDateMonth = (e) => {
    try {
      dispatch(expiryDateAction(`${expiryDateYearEl.current.value}-${expiryDateMonthEl.current.value}-${expiryDateDayEl.current.value}`))
      // validateExpiryDate()
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleExpiryDateYear = (e) => {
    try {
      const regex = RegExp(/^$|^\d+$/)
      if (regex.test(expiryDateYearEl.current.value)) {
        dispatch(expiryDateAction(`${expiryDateYearEl.current.value}-${expiryDateMonthEl.current.value}-${expiryDateDayEl.current.value}`))
        //validateExpiryDate()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurExpiryDate = () => {
    SetIsFocussed(false)
    validateExpiryDate()
  }

  const months = [
    { name: 'January', value: 1 },
    { name: 'February', value: 2 },
    { name: 'March', value: 3 },
    { name: 'April', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'August', value: 8 },
    { name: 'September', value: 9 },
    { name: 'October', value: 10 },
    { name: 'November', value: 11 },
    { name: 'December', value: 12 },
  ]

  return (
    <div className={styles['fields_margin']}>
      <div
        className={
          expiryDateValid === true
            ? expiryDate === '' || expiryDate === '--'
              ? ''
              : 'form-group has-success'
            : expiryDateValid === false
            ? 'form-group ns-form-group-message-error'
            : ''
        }
      >
        <label className="control-label" htmlFor="text">
          <b>{t('insurance_information.expiry_date')}</b>
        </label>
        <div className="help-field ns-hint" style={{ marginTop: '3px' }}>
          {t('insurance_information.expiry_date_example')}
        </div>
        {expiryDateValid === false && (
          <div className="ns-form-error-container has-error error-msg-align">
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(expiryDateError)}</div>
          </div>
        )}
        <div className={[styles['date-align']]}>
          <div className={styles['day_field']}>
            <label className="control-label" htmlFor="ExpiryDate" style={{ marginBottom: '0px' }}>
              <b>{t('insurance_information.dd')}</b>
            </label>
          </div>
          <div className={styles['month_field']}>
            <label className="control-label" htmlFor="ExpiryMonth" style={{ marginBottom: '0px' }}>
              <b>{t('insurance_information.month')}</b>
            </label>
          </div>
          <div className={styles['year_field']}>
            <label className="control-label" htmlFor="ExpiryYear" style={{ marginBottom: '0px' }}>
              <b>{t('insurance_information.yyyy')}</b>
            </label>
          </div>
        </div>
        <div className={[styles['date-align'], expiryDateValid === false && 'has-error'].join(' ')}>
          <input
            ref={expiryDateDayEl}
            type="text"
            id="ExpiryDate"
            aria-labelledby="ExpiryDate"
            className={['form-control', styles['day_field']].join(' ')}
            value={expiryDate.split('-')[2] || ''}
            onChange={handleExpiryDateDay}
            // onBlur={onBlurExpiryDate}
            onFocus={() => SetIsFocussed(true)}
            autoComplete="off"
            maxLength="3"
          />
          <div className="select fw-20">
            <select
              ref={expiryDateMonthEl}
              id="ExpiryMonth"
              aria-labelledby="ExpiryMonth"
              value={expiryDate.split('-')[1] || ''}
              onChange={handleExpiryDateMonth}
              // onBlur={onBlurExpiryDate}
              onFocus={() => SetIsFocussed(true)}
              className={['form-control', styles['month_field']].join(' ')}
            >
              <option value="">Select Month</option>
              {months.map((month) => (
                <option key={month.value} value={formatMonth(month.value)}>
                  {month.name}
                </option>
              ))}
            </select>
          </div>
          <input
            ref={expiryDateYearEl}
            type="text"
            id="ExpiryYear"
            aria-labelledby="ExpiryYear"
            className={['form-control', styles['year_field']].join(' ')}
            value={expiryDate.split('-')[0] || ''}
            onChange={handleExpiryDateYear}
            autoComplete="off"
            //onBlur={onBlurExpiryDate}
            onFocus={() => SetIsFocussed(true)}
            maxLength="4"
          />
        </div>
        {/* <input
          ref={expiryDateMonthEl}
          type="text"
          id="ExpiryMonth"
          aria-labelledby="ExpiryMonth"
          className={['form-control', styles['month_field']].join(' ')}
          value={expiryDate.split('-')[1] || ''}
          onChange={handleExpiryDateMonth}
          autoComplete="off"
          onBlur={onBlurExpiryDate}
          onFocus={() => SetIsFocussed(true)}
          maxLength="3"
        /> */}

        {expiryDateValid === true && (expiryDate === '--' || expiryDate === '') && (
          <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
        )}
      </div>
    </div>
  )
}

export default withTranslation('common')(ExpiryDate)
